module.exports = __webpack_public_path__ + "static/example_agenda-edfe587dcc4000812b160a96e7467974.png";